/* eslint-disable @typescript-eslint/no-var-requires */

const {
  renderApp
} = require(`./internal/${"app"}-auth-app-renderer`);
export { renderApp };